<template>
    <section id="choice" class="page">
        <header class="main">
            <h1><img class="logo" src="img/logo.svg" width="40" alt="" />Rozgrzewka głosu</h1>
        </header>

        <div class="content">
            <div class="container-fluid">
                <div class="top row">
                    <router-link class="col col-6 mini" :to="{ name: 'training', params: {training_type: 5, step_number: 1} }">
                        <h2>Mini<br />rozgrzewka</h2>
                        <div class="btn-wrapper">
                            <div class="clock">
                                <img src="img/clock_1.svg" width="30" alt="" />
                                <span>5 min.</span>
                            </div>
                            <span class="btn btn-primary">Zacznij</span>
                        </div>
                    </router-link>

                    <router-link class="col col-6 midi" :to="{ name: 'training', params: {training_type: 10, step_number: 1}  }">
                        <h2>Midi<br />rozgrzewka</h2>
                        <div class="btn-wrapper">
                            <div class="clock">
                                <img src="img/clock_2.svg" width="30" alt="" />
                                <span>10-15 min.</span>
                            </div>
                            <span class="btn btn-primary">Zacznij</span>
                        </div>
                    </router-link>
                </div>
                <div class="bottom row">
                    <router-link class="col maxi" :to="{ name: 'training', params: {training_type: 15, step_number: 1}  }">
                        <h2>Maxi<br />rozgrzewka</h2>
                        <div class="btn-wrapper">
                            <span class="btn btn-primary">Zacznij</span>
                            <div class="clock">
                                <img src="img/clock_3.svg" width="30" alt="" />
                                <span>15-20 min.</span>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import touch from '../mixins/touch'

export default {
    name: 'Choice',
    mixins: [touch]
}
</script>
